// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal del chat */
.web-chat-container {
    /* display: flex;
    flex-direction: column;
    height: 100vh; */
    font-family: sans-serif;
    background-color: #f0f2f5;
    /* margin-top: 50px; */
}

/* Lista de mensajes */
.messages-list {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sent-row .message-bubble{
    margin-left: 10px;
}

/* Burbuja de mensaje base */
.message-bubble {
    max-width: 70%;
    padding: 10px 15px;
    border-radius: 20px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    word-wrap: break-word;
}

/* Estilo para mensajes enviados (por el usuario) */
.message-bubble.sent {
    align-self: flex-end;
    background-color: #007bff;
    color: white;
    border-bottom-right-radius: 5px;
}

/* Estilo para mensajes recibidos (del otro usuario) */
.message-bubble.received {
    align-self: flex-start;
    background-color: #ffffff;
    color: #333;
    border-bottom-left-radius: 5px;
}
.message-bubble.received .message-text {
    margin-bottom: 10px;
}

/* Texto del mensaje */
.message-text {
    font-size: 16px;
}

/* Información del mensaje (autor y hora) */
.message-info {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    text-align: right;
}

.message-bubble.received .message-info {
    color: #666;
    text-align: left;
}

/* Formulario de entrada de mensaje */
.message-input-form {
    display: flex;
    background-color: #fff;
    align-items: center;
}

/* Campo de texto */
.message-input {
    flex-grow: 1;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 20px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.2s;
}

.message-input:focus {
    border-color: #007bff;
}

/* Botón de envío */
.send-button {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 20px;
    margin-left: 10px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.send-button:hover {
    background-color: #0056b3;
}

.send-button:disabled {
    background-color: #a0c4ff;
    cursor: not-allowed;
}

/* Estilo para el indicador de carga */
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Chat/WebChat.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI;;oBAEgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4BAA4B;AAC5B;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA,mDAAmD;AACnD;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA,sDAAsD;AACtD;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":["/* Contenedor principal del chat */\n.web-chat-container {\n    /* display: flex;\n    flex-direction: column;\n    height: 100vh; */\n    font-family: sans-serif;\n    background-color: #f0f2f5;\n    /* margin-top: 50px; */\n}\n\n/* Lista de mensajes */\n.messages-list {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.sent-row .message-bubble{\n    margin-left: 10px;\n}\n\n/* Burbuja de mensaje base */\n.message-bubble {\n    max-width: 70%;\n    padding: 10px 15px;\n    border-radius: 20px;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n    word-wrap: break-word;\n}\n\n/* Estilo para mensajes enviados (por el usuario) */\n.message-bubble.sent {\n    align-self: flex-end;\n    background-color: #007bff;\n    color: white;\n    border-bottom-right-radius: 5px;\n}\n\n/* Estilo para mensajes recibidos (del otro usuario) */\n.message-bubble.received {\n    align-self: flex-start;\n    background-color: #ffffff;\n    color: #333;\n    border-bottom-left-radius: 5px;\n}\n.message-bubble.received .message-text {\n    margin-bottom: 10px;\n}\n\n/* Texto del mensaje */\n.message-text {\n    font-size: 16px;\n}\n\n/* Información del mensaje (autor y hora) */\n.message-info {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.7);\n    text-align: right;\n}\n\n.message-bubble.received .message-info {\n    color: #666;\n    text-align: left;\n}\n\n/* Formulario de entrada de mensaje */\n.message-input-form {\n    display: flex;\n    background-color: #fff;\n    align-items: center;\n}\n\n/* Campo de texto */\n.message-input {\n    flex-grow: 1;\n    padding: 10px 15px;\n    border: 1px solid #ccc;\n    border-radius: 20px;\n    font-size: 16px;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.message-input:focus {\n    border-color: #007bff;\n}\n\n/* Botón de envío */\n.send-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 20px;\n    padding: 10px 20px;\n    margin-left: 10px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.send-button:hover {\n    background-color: #0056b3;\n}\n\n.send-button:disabled {\n    background-color: #a0c4ff;\n    cursor: not-allowed;\n}\n\n/* Estilo para el indicador de carga */\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
